import React from 'react'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SwitchUI from '../../../widgets/action/SwitchUI'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import BankAnalyzerSF from '../../../components/superUser/clientTxn/BankAnalyzerSF'
import ClientTxnCatTotalListUI from '../../../components/superUser/clientTxn/ClientTxnCatTotalListUI'
import './ClientTxnCatTotalListPage.css'

const ClientTxnCatTotalListPageUI = ({ context, account, errorList, categoryTotalList,
  onRefreshClick, manualOnly, onManualOnly, allAuto, onAllAuto,
  financialYear
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_txn_cat' backLink='/su/accounts'
    headerText={`${account ? account.accountName : ''}`} dimension='w768'
    centered={!account || !categoryTotalList} account={account} page='clientTxnCats'
  >
    {
      (!account || !categoryTotalList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }

      {
        categoryTotalList &&
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
              <span className='g_m_left_100 g_large'><b>Bank Analyzer</b></span>
            </span>
          }
          right={
            <div className='g_flex_v g_small'>
              <span className='g_flex_h g_flex_right g_m_top_50'>
                <span className='g_muted g_m_right_50'>
                  Show manual interventions only (in red)
                </span>
                <SwitchUI
                  checked={manualOnly}
                  onChange={onManualOnly}
                />
              </span>
              <span className='g_flex_h g_flex_right g_m_top_50'>
                <span className='g_muted g_m_right_50'>
                  Show totals without manual intervention (in purple)
                </span>
                <SwitchUI
                  checked={allAuto}
                  onChange={onAllAuto}
                />
              </span>
            </div>
          }
        />
      }

    {
      account && categoryTotalList &&
      <BankAnalyzerSF context={context} account={account} show={true}
        onRefreshClick={onRefreshClick}
      />
    }

      {
        categoryTotalList && categoryTotalList.length === 0 &&
        <EmptyListUI
          context={context}
          createDisabledMessageLabel='No categories'
        />
      }
      {
        categoryTotalList && categoryTotalList.length !== 0 &&
        <ClientTxnCatTotalListUI
          context={context}
          account={account}
          financialYear={financialYear}
          categoryTotalList={categoryTotalList}
          manualOnly={manualOnly}
          allAuto={allAuto}
        />
      }
  </SuperUserAccountPageUI>

export default ClientTxnCatTotalListPageUI
